import type {BookingReason, BookingReasons, Goal} from ".";
import type {CustomerType} from "./customer";
export const basisTypeNames = ["Massage", "Training", "Yoga"] as const;
export type BasisTypeName = typeof basisTypeNames[number];
export type BasisTypes = BasisType[];

export class BasisType {
  name: BasisTypeName;
  id: number;
  private _goals: Goal[] = [];
  private _bookingReasons: Set<BookingReason> = new Set();
  private _allowedCustomerTypes = new Set<CustomerType>();

  constructor(name: BasisTypeName, id: number) {
    this.name = name;
    this.id = id;
  }

  public addBookingReason(reason: BookingReason): void {
    this._bookingReasons.add(reason);
  }

  public addBookableBy(customerType: CustomerType): void {
    this._allowedCustomerTypes.add(customerType);
  }

  public canBeBookedBy(customerType: CustomerType): boolean {
    return this._allowedCustomerTypes.has(customerType);
  }

  public addGoals = (goals: Goal[]): BasisType => {
    goals.forEach(this.addGoal);
    return this;
  };

  public addGoal = (goal: Goal): void => {
    if (!this._goals.includes(goal)) {
      this._goals = [...this._goals, goal];
    }
  };

  public get goals(): Goal[] {
    return [...this._goals];
  }

  public get bookingReasons(): BookingReasons {
    return [...this._bookingReasons];
  }
}
